<script>
    import MultiSelect from "../../MultiSelect.svelte";
    import TextArea from "../../library/TextAreaAutosize.svelte";

    export let linkUrl = '';
    export let onClose;
    export let propsForForm;
    let subscriptionIDs;
    let subscriptions;
    let binSub = {id: ''};

    $: subscriptions = propsForForm && propsForForm[0];
    $: binSub = subscriptions.find(sub => sub.shortCode === '!bin');

    const createItem = () => {
        fetch(`/api/v1/add-item`, {
            body: JSON.stringify({
                subscriptionIDs,
                 linkUrl,
            }),
            method: 'POST',
        })
        .then(res => {
            onClose();
        });
    }
</script>

<form id="new-item-form">
    <TextArea
        bind:value={linkUrl}
        class="input"
        type="text"
        name="item-url"
        minRows={3}
        maxRows={40}
        autocomplete="off"
        placeholder={`url\n\n#usefulhashtag #anotherhashtag`}
        data-required="true"
        required
    />
    <MultiSelect id='subscription-multiselect'
        bind:value={subscriptionIDs}
        initialValue={[binSub?.id || '']}
    >
        {#each subscriptions as subscription}
            <option value={subscription.id}>{subscription.name}</option>
        {/each}
    </MultiSelect>
    <button on:click|preventDefault={() => createItem()} type="submit" form="new-item-form" class="primary-red">
        Add Link
    </button>
</form>

<style>
    #new-item-form {
        display: flex;
        flex-direction: column;
    }
</style>